import { AuthApiPath, CONTENT_TYPE_FORM } from "@/lib/auth/constants";
import * as QueryString from "querystring";
import { buildApiEndpoint } from "@/lib/auth/buildApiEndpoint";

export interface ValidatePasswordPayload {
  password: string;
  [key: string]: any;
}

/**
 * Validate a password using the LMS registration validation endpoint
 * @param payload The password and any additional fields
 * @returns The error message if invalid, or an empty string if valid
 */
export default async function validatePassword(
  payload: ValidatePasswordPayload,
): Promise<string> {
  const url = buildApiEndpoint(AuthApiPath.RegFieldValidation);

  const headers = {
    "Content-Type": CONTENT_TYPE_FORM,
  };

  const body = QueryString.stringify(payload);

  const res = await fetch(url, {
    method: "POST",
    headers,
    body,
    credentials: "include",
  });
  if (!res.ok) {
    throw new Error(`Password validation failed: ${res.status}`);
  }
  const data = await res.json();
  if (data.validation_decisions && data.validation_decisions.password) {
    return data.validation_decisions.password;
  }
  return "";
}
